import React from "react"
import { SensaiComponentIndividualButtonDef } from "../../../gql/generated/graphql"
import { Button } from "../../ui/Button"
import { Box } from "@mui/system"

const ContentButton = ({
  link,
  align,
  margin,
  allowCardAreaFill,
}: {
  link?: SensaiComponentIndividualButtonDef
  align?: "center" | "start" | "end"
  margin?: string
  allowCardAreaFill?: boolean
}) => {
  if (!link) {
    return null
  }

  const {
    id,
    title,
    type,
    anchor,
    urlLink,
    product,
    page,
    landingPage,
    blog,
    addToCart,
  } = link

  const fillCardArea = allowCardAreaFill && type === "cardArrow"

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: align ?? "inherit",
        margin: fillCardArea ? 0 : margin ?? "2rem 0.5rem 0",
        width: fillCardArea ? "100%" : "auto",
        height: fillCardArea ? "100%" : "auto",
      }}
    >
      <Button
        sectionId={`${id}-card`}
        type={fillCardArea ? "cardArrowFull" : (type as any)}
        title={title}
        link={[
          {
            anchor: anchor ?? undefined,
            linkText: title,
            url: urlLink ?? "",
            addToCart: addToCart,
            ...(page?.slug
              ? {
                  navItemPage: {
                    id: page.id,
                    slug: page.slug,
                  },
                }
              : {}),
            ...(landingPage?.slug
              ? {
                  navItemLandingPage: {
                    id: landingPage.id,
                    slug: landingPage.slug,
                  },
                }
              : {}),
            ...(blog?.slug
              ? {
                  navItemPage: {
                    id: blog.id,
                    slug: `/blog/${blog.slug}`,
                  },
                }
              : {}),
            ...(product?.slug
              ? {
                  product: {
                    stripeId: product.stripeId ?? undefined,
                    stripeTestId: product.stripeTestId ?? undefined,
                    slug: product.slug,
                  },
                }
              : {}),
          },
        ]}
      />
    </Box>
  )
}

export default ContentButton
